var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreezer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 1.875H5.37915C4.68879 1.875 4.12915 2.43464 4.12915 3.125V15.8667C4.12915 16.557 4.68879 17.1167 5.37915 17.1167H14.625C15.3153 17.1167 15.875 16.557 15.875 15.8667V3.125C15.875 2.43464 15.3153 1.875 14.625 1.875Z",
    stroke: "#101828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12915 8.20416H15.8708M6.44582 6.60416V4.07916M6.44582 12.15V9.625M5.26665 17.1167V17.5542C5.26665 17.7048 5.32622 17.8494 5.43237 17.9563C5.53852 18.0633 5.68265 18.1239 5.83332 18.125H6.86248C7.01388 18.125 7.15907 18.0649 7.26612 17.9578C7.37318 17.8507 7.43332 17.7056 7.43332 17.5542V17.1167M12.5625 17.1167V17.5542C12.5625 17.7056 12.6226 17.8507 12.7297 17.9578C12.8367 18.0649 12.9819 18.125 13.1333 18.125H14.1667C14.318 18.125 14.4632 18.0649 14.5703 17.9578C14.6773 17.8507 14.7375 17.7056 14.7375 17.5542V17.1167",
    stroke: "#101828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezer);
export default __webpack_public_path__ + "static/media/Freezer.cc3b504ec8e74c63e7db444cce329b81.svg";
export { ForwardRef as ReactComponent };